import InfoContainer from '../../components/Info/InfoConatiner';
import TabbedSection from '../../components/TabbedSection/TabbedSection';
import QuickEstimateCalculator from '../../components/QuickEstimateCalculator/QuickEstimateCalculator';
import { useAtom } from 'jotai';
import useAEMFetch from '../../api/useAEMFetch';
import { useEffect } from 'react';
import { aemContent } from '../../state/globalState';
import environment from '../../environment';
import { CircularActivityIndicator } from '@cxc/react-fds-components';
import DocumentHead from '../../components/DocumentHead';
import { constructDigitalData, fireAnalyticsEvent } from '../../analytics/analytics';
import { GLOBAL_LOAD, PAGE_NAME } from '../../analytics/analyticsConstants';
import { useUniversalContext } from '@cxc/react-universal-components';
import { AnalyticsConstants } from '../../utils/constants';
import Disclosure from '../../components/Disclosure/Disclosure';

export default function LandingPage() {
    const [aem] = useAtom(aemContent);
    const [getAEMvalues] = useAEMFetch();
    const { isLoggedIn, subscribeScopedValue } = useUniversalContext();
    const cookiePreferences = subscribeScopedValue(AnalyticsConstants.FPG_COOKIES, AnalyticsConstants.COOKIE_PREFERENCES);

    useEffect(() => {
        if (aem && Object.keys(aem).length !== 0) {
            checkAdobeLaunch();
        } else {
            initializeAem();
        }
    }, [aem]);

    const checkAdobeLaunch = () => {
        const checkAdobeLaunchInterval = setInterval(() => {
            if (window._satellite && typeof window._satellite === 'object') {
                clearInterval(checkAdobeLaunchInterval);
                const digitalData = constructDigitalData(GLOBAL_LOAD, PAGE_NAME, GLOBAL_LOAD, '', '', '', isLoggedIn, cookiePreferences);
                fireAnalyticsEvent(digitalData.digitalData, digitalData.directCallName);
            }
        }, 100);
    };

    const initializeAem = async () => {
        console.log('Environment variables ENV: ', environment);
        console.log('Environment variables process: ', process.env);
        getAEMvalues();
    };

    return (
        // fds-app classname needed to have CXC styling across FDS and FDPS components remain same - reference here - https://ford-pro.slack.com/archives/C02UQT7NKLK/p1706880462518829
        <div className="fds-app">
            <>
                {Object.keys(aem).length !== 0 ? (
                    <>
                        {aem?.seoconfig && <DocumentHead {...aem?.seoconfig?.props?.google} data-testid="landing-page" />}
                        <InfoContainer />
                        <TabbedSection />
                        <QuickEstimateCalculator />
                        <Disclosure />
                    </>
                ) : (
                    <>
                        <div
                            style={{
                                height: '50vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <CircularActivityIndicator />
                        </div>
                    </>
                )}
            </>
        </div>
    );
}
